import React from "react"
import { DisplayValue } from "../../../utilities/displayValue"
import RaiStatusBadge from "../../shared_components/request_thread/RaiStatusBadge";
import { COPY } from "../../shared_components/request_thread/copy";

// Plain CLOSED renders as slate text (matching the Outstanding table's
// `text-slate-500` lifecycle tone), not a filled pill (sc-28540).
const STATUS_TEXT_STYLE = {
  display: 'inline-block',
  padding: '0.25rem 0.5rem',
  color: COPY.hex.slate500,
  fontSize: '0.75rem',
  fontWeight: 600,
  textTransform: 'uppercase',
};

const IssueRow = ({ issue, isSelected, toggleSelectIssue, onNavigate }) => {
  const overlay = issue.rai_status_overlay;

  return (
    <tr className={issue?.id ? 'cursor-pointer' : 'cursor-not-allowed'}>
      <td>
        <div className="flex justify-start align-center">
          <input
            type="checkbox"
            className="h-5 w-6"
            checked={isSelected}
            onChange={() => toggleSelectIssue()}
          />
        </div>
      </td>
      <td onClick={() => onNavigate(issue)}>
        <div>
          <span className='capitalize'>{DisplayValue(issue.patient_profile?.last_name)}</span>,
          <span className='capitalize'> {DisplayValue(issue.patient_profile?.first_name)}</span>
        </div>
        <div>
          {DisplayValue(issue.patient_profile?.gender)}
        </div>
        {DisplayValue(issue.patient_profile?.dob)}
        <div>
        </div>
        <div>
          {DisplayValue(issue.patient_profile?.personal_health_number)}
        </div>
      </td>
      <td onClick={() => onNavigate(issue)}>{DisplayValue(issue.primary_physician.name)}</td>
      <td onClick={() => onNavigate(issue)}>{DisplayValue(issue.get_consultant)}</td>
      <td onClick={() => onNavigate(issue)}>{DisplayValue(issue?.completed_at)}</td>
      <td onClick={() => onNavigate(issue)}>{DisplayValue(issue?.diagnosis)}</td>
      <td onClick={() => onNavigate(issue)}>
        {overlay ? (
          <RaiStatusBadge overlay={overlay} />
        ) : (
          !issue.is_open && (
            <span style={STATUS_TEXT_STYLE}>
              {COPY.status.closed}
            </span>
          )
        )}
      </td>
    </tr>
  )
}


export default IssueRow
